import axios, { AxiosRequestConfig } from 'axios';

import NN05FormEmployeeData from '../models/payload/NN05FormEmployeeData';
import NN05FormListData from '../models/payload/NN05FormListData';
import U from './Utils';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

const _timeOut = 300000;

export const APIgetEmployeeListByFirm = (formData: NN05FormListData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/EmployeeListByFirm`, 
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
     Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

// Excel
export const APIgetNN05ExcelData = (formData: NN05FormListData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/ExcelEmployeeData`,
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    data: formData,
    responseType: 'blob',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
  /**/
};



export const APIpostNN05EmployeeInsert = (formData: NN05FormEmployeeData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee`,
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const APIpostNN05EmployeeUpdate = (formData: NN05FormEmployeeData) => {
  const config = {
    method: 'put',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee`,
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
     Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const APIdeleteEmployee = (employeeId: string) => {
  const config = {
    method: 'delete',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/${Utils.T_companyNr}/${employeeId}`,
    timeout: _timeOut,
    headers: {
      Authorization: `Bearer ${CSharpUtils.Get_Token}`
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const APIgetNN05EmployeeId = () => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/NewEmployeeId/`,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
     Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
  /**/
};

export const APIvalidateNN05EmployeeId = (EmployeeId: string) => {

  console.log('APIvalidateNN05EmployeeIdAPIvalidateNN05EmployeeIdAPIvalidateNN05EmployeeId');
  
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/ValidateEmployeeId/` + EmployeeId,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
     Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
  /**/
};

export const APIgetNN05EmployeeIdValidate = (employeeId: string) => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/employee/ValidateEmployeeId/` + employeeId,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    params: { employeeId },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
  /**/
};

export const APIgetNN05LocationByPostalCode = (postalcode: string) => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/postal/` + postalcode,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
   //arams: { postalcode },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
}
